import { render, staticRenderFns } from "./payment.component.vue?vue&type=template&id=4ef62ab0"
import script from "./payment.component.vue?vue&type=script&lang=js"
export * from "./payment.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports